module.exports = __webpack_public_path__ + "img/sampleimg.aad30d06.png";